module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_fails.js
// module id = 77
// module chunks = 0 1